import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CoreCommonModule } from '@core/common.module';

import { FooterComponent } from 'app/layout/components/footer/footer.component';
import { ScrollTopComponent } from 'app/layout/components/footer/scroll-to-top/scroll-top.component';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@NgModule({
  declarations: [FooterComponent, ScrollTopComponent],
  imports: [RouterModule, CoreCommonModule,TranslateModule],
  exports: [FooterComponent]
})
export class FooterModule {
  messages: { emptyMessage: any; totalMessage: any; selectedMessage: any; };

   constructor( 
     
          private translate: TranslateService,
                  private toastr: ToastrService
    ) {} 
    ngOnInit(): void {
    
    
    const currentUser = localStorage.getItem('currentUser');
   
    
    this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this.translate.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });
  }

  private setDatatableMessages() {
    this.messages = {
      emptyMessage: this.translate.instant('MENU.DASHBOARD.no_data_available') || 'لا توجد بيانات متاحة',
      totalMessage: this.translate.instant('MENU.DASHBOARD.total') || 'الإجمالي',
      selectedMessage: this.translate.instant('MENU.DASHBOARD.selected') || 'محدد'
    };
  }
}
